<template>
	<div id="testeeee">
		<div v-if="localLoading" class="loader"></div>
		<b-input-group size="md">
			<b-form-input
				id="searchInput"
				v-model="filter"
				v-on:keyup.enter="searchFilter"
				type="text"
				:name="name"
				:readonly="!active"
			></b-form-input>
			<b-input-group-append>
				<b-input-group-text @click="searchFilter">
					<b-icon icon="search" />
				</b-input-group-text>
			</b-input-group-append>
		</b-input-group>

		<div class="notFoundButton" v-if="!isList">
			<a href="#" @click="showInputMethod">{{ $t("components.kSearch.notFound") }}</a>
		</div>
		<b-form-input
			:readonly="!active"
			v-show="showInput"
			id="customInput"
			type="text"
			:value="filter"
			:state="state"
			name="customInput"
			v-model="proxyValue"
		></b-form-input>
		<div class="optionsList">
			<div id="scrollDad">
				<b-form-radio-group
					id="scrollDiv"
					:disabled="!active"
					:options="demo_options"
					v-model="proxyValue"
					button-variant="outline-primary"
					:state="state"
					stacked
					buttons
					@change="optionChange"
				>
				</b-form-radio-group>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	props: {
		options: {
			type: Array,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		value: {
			required: false
		},
		data: {
			type: Object
		},
		state: {
			type: Boolean,
			default: null
		},
		type: {
			type: String
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		errors: {
			type: Object
		}
	},
	data() {
		return {
			page: 1,
			filter: "",
			demo_options: [],
			localLoading: false,
			showInput: false,
			active: true
		};
	},
	methods: {
		...mapActions(["getOptionsByPage"]),
		getNextPage: function () {
			this.page++;
			this.getPage();
		},
		searchFilter: function () {
			this.demo_options = [];
			this.page = 1;
			this.getPage();
		},
		getPage: function () {
			this.localLoading = true;
			let obj = {
				body: {
					pageOfList: this.page,
					limitOfList: 10,
					filter: this.filter,
					isList: false
				},
				name: this.name
			};
			this.getOptionsByPage(obj)
				.then((response) => {
					let _response = [];
					_response = this.isList
						? response.data.data.list.map((obj) => {
								return { text: obj.description, value: obj.key };
						  })
						: response.data.data.list.map((obj) => {
								return { text: obj.description, value: obj.description };
						  });
					this.demo_options = [...this.demo_options, ..._response];
					this.localLoading = false;
					let option = this.demo_options.find((item) => item.text == this.value);
					if (!option) this.value = null;
				})
				.catch((error) => {
					console.error("Erro ao buscar lista de opções: ", error);
					this.localLoading = false;
				});
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		handleScroll: function () {
			let container = this.$el.querySelector("#scrollDad");
			if (container.scrollTop + 400 == container.scrollHeight) {
				this.getNextPage();
			}
		},

		showInputMethod: function () {
			this.showInput = true;
			this.proxyValue = this.filter;
			setTimeout(() => {
				this.$el.querySelector('[name="customInput"]').focus();
				this.$el.querySelector('[name="customInput"]').setSelectionRange(0, this.filter.length);
			}, 100);
		},

		optionChange: function () {
			this.showInput = false;
		}
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.value = newValue;
				this.$emit("input", newValue);
				this.$emit("change", this.name);
			}
		},

		isList: function () {
			return this.type == "Search" ? false : true;
		}
	},

	mounted() {
		let container = this.$el.querySelector("#scrollDad");
		container.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		let container = this.$el.querySelector("#scrollDad");
		container.removeEventListener("scroll", this.handleScroll);
	},

	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;

		if (this.value) {
			if (this.isList) {
				this.localLoading = true;
				let obj = {
					body: {
						pageOfList: this.page,
						limitOfList: 10,
						filter: this.value,
						isList: true
					},
					name: this.name
				};

				this.getOptionsByPage(obj)
					.then((response) => {
						let _response = response.data.data.list.map((obj) => {
							return { text: obj.description, value: obj.key };
						});
						if (_response.length == 0) this.getPage();
						else {
							this.demo_options = _response;
						}

						this.localLoading = false;
					})
					.catch((error) => {
						console.error("Erro ao buscar lista de opções: ", error);
						this.localLoading = false;
					});
			} else this.demo_options.push(this.value);
		} else this.getPage();
	}
};
</script>
<style scoped>
.btn {
	margin-top: 5px !important;
}

input {
	margin-top: 10px !important;
}

#scrollDad {
	display: flex;
	flex-direction: column;
	overflow: auto;
	height: 400px;
}

#searchInput {
	margin-top: 0px !important;
}

.input-group-append:focus .input-group-text {
	background-color: black;
}

.input-group-append {
	cursor: pointer;
}

.loader {
	position: absolute;
	left: 48%;
	top: 25vh;
	border: 5px solid #f3f3f3;
	border-top: 4px solid #104a4d;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	-webkit-animation: spin-data-v-439cf7ac 2s linear infinite;
	animation: spin-data-v-439cf7ac 2s linear infinite;
	z-index: 999;
}

.notFoundButton {
	height: 20px;
}
.notFoundButton a {
	float: right;
}

.optionsList {
	display: block;
}
</style>
